import useGetCustomerApplications from './useGetCustomerApplications'

export default useGetCustomerApplications
